import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import '../html-template/styles.css';
import '../html-template/model-color.scss';

import { range, keyBy } from 'lodash';

import axios from 'axios';

class ModelColor extends Component {
    constructor(props){
        super(props);

        this.model_data = {
            '1': 12,
            '2': 9,
            '3': 10,
            '4': 9,
            '5': 8,
            '6': 11,
            '7': 11,
            '8': 10,
            '9': 17,
        };

        this.model_fixed = {
            //'1': {
            //    7: 64,
            //    10: 68,
            //},
            '3': {
                5: 64,
                6:64,
                8: 68,
            },
            '4': {
                5: 64,
                4: 64,
                9: 68,
            },
            '5': {
                6: 65,
                7: 65,
                5: 68,
                8: 24,
            },
            '6': {
                8: 64,
                9: 64,
                10: 64,
                11: 68,
            },
            '7': {
							4: 64,
							7: 63,
							8: 68
            //    8: 64,
            //    9: 64,
            //    13: 68,
            //    12: 64,
            //    11: 64,
            },
            '8': {
                7: 64,
                9: 64,
                8: 68,
            },
            '9': {
                1: 64,
                4: 64,
                5: 64,
                8: 64,
                10: 68,
                11: 68,
                12: 68,
                13: 64,
                15: 68,
                16: 68,
                17: 68,
            }
        }


        this.color_group_label = {
            "1": "Đen",
            "2": "Xanh dương",
            "3": "Đồng - gold",
            "4": "Xanh lá",
            "5": "Cam - vàng - hồng",
            "6": "Đỏ",
            "7": "Xám",
            "8": "Trắng - bạc",
            "9": "Trắng",
            "10": "Đen",
            "11": "Bạc",
            "12": "Xám"
        }


        if(this.props.location && this.props.location.state){
            const { resp, current_color, current_model } = this.props.location.state;
            const model = current_model ? current_model : '1';
					const all_colors_parts = [];
					current_color.forEach(cl => {
            const parts = range(1, this.model_data[model]+1).map((i) => { 
                let colr = undefined;

                if(this.model_fixed.hasOwnProperty(model) && this.model_fixed[model].hasOwnProperty(i)){
                    colr = this.model_fixed[model][i];
                }
                    
                return {
                    code: i.toString(),
									color: colr ? {code: colr.toString()} : (cl ? cl : {code: '1'})
                }
            });

						all_colors_parts.push(keyBy(parts, 'code'));
					});

            this.state = {
                phase: 1,
                colors: [],
                current_part: undefined,
                num_of_part: this.model_data[model],
                model: model,
                parts: all_colors_parts,
                resp,
                change_all: true,
                current_step: 1,
                num_of_steps: 2,
                steps_completed: [],
                dream_color: current_color,
                base_color: current_color,
                saving: false,
                successful: false,
							  popup_content: null
            }

            this.line_data = {
                '1': [
                        {part:1, x1:189, y1:248, x2:40, y2:30 },
                        {part:2, x1:515, y1:282, x2:280, y2:30 },
                        {part:3, x1:370, y1:416, x2:100, y2:30 },
                        {part:4, x1:594, y1:310, x2:520, y2:30 },
                        {part:5, x1:529, y1:169, x2:460, y2:30 },
                        {part:6, x1:444, y1:142, x2:400, y2:30 },
                        {part:7, x1:409, y1:354, x2:160, y2:30 },
                        {part:8, x1:408, y1:301, x2:220, y2:30 },
                        {part:9, x1:487, y1:225, x2:340, y2:30 },
                        {part:10, x1:623, y1:387, x2:580, y2:30 },
                ],
                '2': [
                        {part:1, x1:201, y1:205, x2:40, y2:30 },
                        {part:2, x1:414, y1:305, x2:100, y2:30 },
                        {part:3, x1:580, y1:211, x2:400, y2:30 },
                        {part:4, x1:488, y1:87, x2:460, y2:30 },
                        {part:5, x1:346, y1:226, x2:160, y2:30 },
                        {part:6, x1:473, y1:165, x2:280, y2:30 },
                        {part:7, x1:449, y1:118, x2:340, y2:30 },
                        {part:8, x1:521, y1:121, x2:520, y2:30 },
                        {part:9, x1:454, y1:239, x2:220, y2:30 },
                ],
                "3": [

                        {part:1, x1:351, y1:367, x2:520, y2:30 },
                        {part:2, x1:280, y1:193, x2:400, y2:30 },
                        {part:3, x1:190, y1:353, x2:340, y2:30 },
                        {part:4, x1:258, y1:290, x2:460, y2:30 },
                        {part:5, x1:133, y1:468, x2:100, y2:30 },
                        {part:6, x1:137, y1:387, x2:160, y2:30 },
                        {part:7, x1:77, y1:288, x2:40, y2:30 },
                        {part:8, x1:356, y1:520, x2:580, y2:30 },
                        {part:9, x1:148, y1:460, x2:220, y2:30 },
                        {part:10, x1:235, y1:115, x2:280, y2:30 },
                ],
                    "4": [
                        {part:1, x1:344, y1:284, x2:340, y2:30 },
                        {part:2, x1:407, y1:194, x2:400, y2:30 },
                        {part:3, x1:331, y1:113, x2:160, y2:30 },
                        {part:4, x1:281, y1:443, x2:280, y2:30 },
                        {part:5, x1:253, y1:341, x2:220, y2:30 },
                        {part:6, x1:466, y1:321, x2:460, y2:30 },
                        {part:7, x1:161, y1:288, x2:40, y2:30 },
                        {part:8, x1:257, y1:470, x2:100, y2:30 },
                        {part:9, x1:487, y1:479, x2:520, y2:30 },
                    ],
                "5": [
                        {part:1, x1:168, y1:326, x2:40, y2:30 },
                        {part:2, x1:361, y1:284, x2:220, y2:30 },
                        {part:3, x1:498, y1:323, x2:460, y2:30 },
                        {part:4, x1:358, y1:116, x2:280, y2:30 },
                        {part:5, x1:451, y1:199, x2:400, y2:30 },
                        {part:6, x1:247, y1:494, x2:100, y2:30 },
                        {part:7, x1:273, y1:398, x2:160, y2:30 },
                        {part:8, x1:498, y1:480, x2:340, y2:30 },
                ],
                "6": [
                        {part:1, x1:565, y1:330, x2:580, y2:30 },
                        {part:2, x1:418, y1:103, x2:400, y2:30 },
                        {part:3, x1:481, y1:208, x2:460, y2:30 },
                        {part:4, x1:151, y1:273, x2:40, y2:30 },
                        {part:5, x1:302, y1:355, x2:220, y2:30 },
                        {part:6, x1:495, y1:185, x2:520, y2:30 },
                        {part:7, x1:379, y1:374, x2:340, y2:30 },
                        {part:8, x1:307, y1:320, x2:280, y2:30 },
                        {part:9, x1:230, y1:356, x2:160, y2:30 },
                        {part:10, x1:218, y1:396, x2:100, y2:30 },
                        {part:11, x1:569, y1:444, x2:640, y2:30 },
                ],
                "7": [
                        {part:1, x1:100, y1:344, x2:40, y2:30 },
                        {part:2, x1:184, y1:213, x2:100, y2:30 },
                        {part:3, x1:314, y1:93, x2:280, y2:30 },
                        {part:4, x1:278, y1:301, x2:160, y2:30 },
                        {part:5, x1:582, y1:211, x2:640, y2:30 },
                        {part:6, x1:265, y1:63, x2:220, y2:30 },
                        {part:7, x1:324, y1:116, x2:340, y2:30 },
                        {part:8, x1:411, y1:328, x2:400, y2:30 },
                        {part:9, x1:449, y1:284, x2:460, y2:30 },
                        {part:10, x1:601, y1:237, x2:700, y2:30 },
                        {part:11, x1:506, y1:310, x2:580, y2:30 },
                        {part:12, x1:478, y1:372, x2:520, y2:30 },
                        {part:13, x1:616, y1:343, x2:760, y2:30 },
                ],
                "8": [
                        {part:1, x1:100, y1:258, x2:40, y2:30 },			
                        {part:2, x1:248, y1:485, x2:100, y2:30 },			
                        {part:3, x1:346, y1:306, x2:280, y2:30 },			
                        {part:4, x1:425, y1:208, x2:460, y2:30 },			
                        {part:5, x1:371, y1:72, x2:400, y2:30 },			
                        {part:6, x1:344, y1:114, x2:340, y2:30 },			
                        {part:7, x1:254, y1:355, x2:160, y2:30 },			
                        {part:8, x1:499, y1:486, x2:580, y2:30 },			
                        {part:9, x1:288, y1:440, x2:220, y2:30 },			
                        {part:10, x1:502, y1:352, x2:520, y2:30 },
                    
                ]
            };

        }else{
            this.state = {};
        }


        this.handleLogout = this.handleLogout.bind(this);
    }

    calc_line_point(left, top, width, height){
        return { x1: left+width/2, y1: top+height/2 }; 
    }


    componentDidMount(){
        axios.get(process.env.PUBLIC_URL + "/assets/json/colors.json")
            .then(resp => {
                this.setState({
                    colors: resp.data
                });
            });
    }


	handleClosePopup = () => {
		this.setState({
			popup_content: null
		});
	}
    partDesClicked(e){
        const part = e.target.getAttribute('data-part');
        this.setState((prev_state) => {
            if(prev_state.current_part !== part){
                return {current_part: part};
            }else{
                return {current_part: undefined};
            }
        });
    }


    handleLogout(){
        let confirm = window.confirm("Bạn có chắc chắn muốn quay về?");
        if(confirm){
            this.props.history.replace({
                pathname: '/'
            });
        }
    }

	renderPopup(model, part_images,c){
	
const popup_content = (<figure onClick={this.handleClosePopup} className="model-image model-1">
						<div className="color-code"
							style={{
								backgroundColor: c.value.bg,
								color: c.value.text
							}}
						>{c.code}</div>
                            <img src={process.env.PUBLIC_URL + '/assets/models/'+model+'/full.png'} alt="full model" className={"model-"+model+"-full"}/>
						{
                                part_images.map((img) => img)
						}
					</figure>);

                this.setState({
									popup_content: popup_content
                });
	}
    render() {
        if(!this.state.resp) return <Redirect pathname="/" />;

        const { colors } = this.state;
			let figures = [];
			this.state.dream_color.forEach((c,j) =>
				{
        let part_images = [];
        for(var i = 1;i<=this.state.num_of_part;i++){
            part_images.push(<img key={i} 
                src={process.env.PUBLIC_URL + '/assets/models/'+this.state.model+'/'+i+'_'+this.state.parts[j][i].color.code+'.png'} 
                alt="full model"
                className={`model-${this.state.model}-part-${i} part ${this.state.current_part === i.toString() ? 'current' : ''}`}
                data-part={i}
                onClick={this.partClicked}/>
            );
        }
					figures.push(<figure onClick={() => this.renderPopup(this.state.model, part_images, c)} key={j} className="model-image model-1">
						<div className="color-code"
							style={{
								backgroundColor: c.value.bg,
								color: c.value.text
							}}
						>{c.code}</div>
						
                            <img src={process.env.PUBLIC_URL + '/assets/models/'+this.state.model+'/full.png'} alt="full model" className={"model-"+this.state.model+"-full"}/>
						{
                                part_images.map((img) => img)
						}
					</figure>
					);
				});
    return (
        <div className="model-color">
            <header className="tool-header">
                <div className="info">
									<strong>Xem 10 màu xe</strong>
        </div>
                <button onClick={this.handleLogout} title="Trở về" className="btn btn--primary" >Về trang chủ<i className="icon ion-md-arrow-round-forward"></i></button>    
            </header>
            <main className="tool-main">
                <div className="left-panel">
                            {
                                figures.map((img) => img)
                            }
                            
                </div>
                <div className="right-panel">
                    <div className="paint-tool">
                        <div className="paint-tool__header">
                            { this.state.current_step === 1 ? "Anh/Chị có thể thử các màu khác làm màu chủ đạo cho chiếc xe này" : "Bây giờ, Anh/Chị có thể phối và kết hợp các màu sắc khác nhau lên từng bộ phận để cho ra chiếc xe mà Anh/Chị ưng ý nhất." }
                        </div>
                        {colors.map((color_group) => 
                        <ul key={color_group[0].Group_Code} className="paint-tool__color">
                            { 
                                color_group.map((color) => 
                                    <li key={color.Code}>
                                        <span 
                                            className="color__item"
                                            data-code={color.Code} 
                                            onClick={this.colorClicked} 
                                            style={{
                                                backgroundColor: `hsl(${color.H},${color.S}%,${color.B}%)`,
                                                color: color.B < 51 ? '#FFF' : '#333'
                                            }}>{color.Code}
                                        </span>
                                    </li>
                                )
                            }
                            <li className="color-label">{this.color_group_label[color_group[0].Group_Code]}</li>
                        </ul>
                        )}
                    </div>
                </div>
							{this.state.popup_content &&
							<div className="model-popup">
								<button title="Close" onClick={this.handleClosePopup} className="close" tabIndex="0">close</button>
								{this.state.popup_content}
							</div>
							}
            </main>
        </div>
    );
  }
}

export default ModelColor;
